let language = lang === null ? 'en' : lang;

$(document).ready(function () {
    //    First bar chart
    if (!/terminal/.test(window.location.href)) {
        var ctx = document.getElementById('myChartDogs1').getContext('2d');
        var chart = new Chart(ctx, {
            // The type of chart we want to create
            type: 'bar',
    
            // The data for our dataset
            data: {
                labels: ["1", "2", "3", "4", "5", "6"],
                datasets: [{
                        label: langArr[language].top_color,
                        backgroundColor: [
                            '#bf1010',
                            '#2e3192',
                            '#b7b7b7',
                            '#323232',
                            '#fff200',
                            '#747473'
    
                        ],
                        data: [29, 35, 30, 26, 23, 30],
                    }]
            },
    
            // Configuration options go here
            options: {
                scales:
                        {
                            xAxes: [{
                                    display: false
                                }],
                            yAxes: [{
                                    gridLines: {
                                        color: "#646464"
                                    }
                                }]
                        },
                legend: {
                    display: false
    
                }
            }
        });
    
    
        //Chart 1
    
        Chart.pluginService.register({
            afterUpdate: function (chart) {
                if (chart.config.options.elements.center) {
                    var helpers = Chart.helpers;
                    var centerConfig = chart.config.options.elements.center;
                    var globalConfig = Chart.defaults.global;
                    var ctx = chart.chart.ctx;
    
                    var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
                    var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);
    
                    if (centerConfig.fontSize)
                        var fontSize = centerConfig.fontSize;
                    // figure out the best font size, if one is not specified
                    else {
                        ctx.save();
                        var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                        var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                        var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);
    
                        do {
                            ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                            var textWidth = ctx.measureText(maxText).width;
    
                            // check if it fits, is within configured limits and that we are not simply toggling back and forth
                            if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                                fontSize += 1;
                            else {
                                // reverse last step
                                fontSize -= 1;
                                break;
                            }
                        } while (true)
                        ctx.restore();
                    }
    
                    // save properties
                    chart.center = {
                        font: helpers.fontString(fontSize, fontStyle, fontFamily),
                        fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
                    };
                }
            },
            afterDraw: function (chart) {
                if (chart.center) {
                    var centerConfig = chart.config.options.elements.center;
                    var ctx = chart.chart.ctx;
    
                    ctx.save();
                    ctx.font = chart.center.font;
                    ctx.fillStyle = chart.center.fillStyle;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText(centerConfig.text, centerX, centerY);
                    ctx.restore();
                }
            },
        })
    
    
        var config = {
            type: 'doughnut',
            data: {
                labels: [
                    langArr[language].more,
                    langArr[language].less
                ],
                datasets: [{
                        data: [60, 40],
                        backgroundColor: [
                            "#35b514",
                            "#555555"
                        ],
                        borderColor: [
                            "#35b514",
                            "#555555"
                        ]
                    }]
            },
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false
                },
                elements: {
                    center: {
                        // the longest text that could appear in the center
                        maxText: '100%',
                        text: langArr[language].low+' 42%',
                        fontColor: '#555555',
                        fontFamily: "'proxima-nova-regular",
                        fontStyle: 'normal',
                        fontSize: 15,
                        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                        // if these are not specified either, we default to 1 and 256
                        minFontSize: 1,
                        maxFontSize: 256,
                    }
                }
            }
        };
    
        var ctx = document.getElementById("myChartDogPie1").getContext("2d");
        var myChart = new Chart(ctx, config);
    
        //Chart 2
    
        Chart.pluginService.register({
            afterUpdate: function (chart) {
                if (chart.config.options.elements.center) {
                    var helpers = Chart.helpers;
                    var centerConfig = chart.config.options.elements.center;
                    var globalConfig = Chart.defaults.global;
                    var ctx = chart.chart.ctx;
    
                    var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
                    var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);
    
                    if (centerConfig.fontSize)
                        var fontSize = centerConfig.fontSize;
                    // figure out the best font size, if one is not specified
                    else {
                        ctx.save();
                        var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                        var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                        var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);
    
                        do {
                            ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                            var textWidth = ctx.measureText(maxText).width;
    
                            // check if it fits, is within configured limits and that we are not simply toggling back and forth
                            if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                                fontSize += 1;
                            else {
                                // reverse last step
                                fontSize -= 1;
                                break;
                            }
                        } while (true)
                        ctx.restore();
                    }
    
                    // save properties
                    chart.center = {
                        font: helpers.fontString(fontSize, fontStyle, fontFamily),
                        fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
                    };
                }
            },
            afterDraw: function (chart) {
                if (chart.center) {
                    var centerConfig = chart.config.options.elements.center;
                    var ctx = chart.chart.ctx;
    
                    ctx.save();
                    ctx.font = chart.center.font;
                    ctx.fillStyle = chart.center.fillStyle;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText(centerConfig.text, centerX, centerY);
                    ctx.restore();
                }
            },
        })
    
    
        var config = {
            type: 'doughnut',
            data: {
                labels: [
                    langArr[language].low,
                    langArr[language].high
                ],
                datasets: [{
                        data: [60, 40],
                        backgroundColor: [
                            "#931a1a",
                            "#555555"
                        ],
                        borderColor: [
                            "#931a1a",
                            "#555555"
                        ]
                    }]
            },
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false
                },
                elements: {
                    center: {
                        // the longest text that could appear in the center
                        maxText: '100%',
                        text: langArr[language].high +' 52%',
                        fontColor: '#555555',
                        fontFamily: "'proxima-nova-regular",
                        fontStyle: 'normal',
                        fontSize: 15,
                        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                        // if these are not specified either, we default to 1 and 256
                        minFontSize: 1,
                        maxFontSize: 256,
                    }
                }
            }
        };
    
        var ctx = document.getElementById("myChartDogPie2").getContext("2d");
        var myChart = new Chart(ctx, config);
    
        //Chart 3
    
        Chart.pluginService.register({
            afterUpdate: function (chart) {
                if (chart.config.options.elements.center) {
                    var helpers = Chart.helpers;
                    var centerConfig = chart.config.options.elements.center;
                    var globalConfig = Chart.defaults.global;
                    var ctx = chart.chart.ctx;
    
                    var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
                    var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);
    
                    if (centerConfig.fontSize)
                        var fontSize = centerConfig.fontSize;
                    // figure out the best font size, if one is not specified
                    else {
                        ctx.save();
                        var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                        var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                        var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);
    
                        do {
                            ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                            var textWidth = ctx.measureText(maxText).width;
    
                            // check if it fits, is within configured limits and that we are not simply toggling back and forth
                            if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                                fontSize += 1;
                            else {
                                // reverse last step
                                fontSize -= 1;
                                break;
                            }
                        } while (true)
                        ctx.restore();
                    }
    
                    // save properties
                    chart.center = {
                        font: helpers.fontString(fontSize, fontStyle, fontFamily),
                        fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
                    };
                }
            },
            afterDraw: function (chart) {
                if (chart.center) {
                    var centerConfig = chart.config.options.elements.center;
                    var ctx = chart.chart.ctx;
    
                    ctx.save();
                    ctx.font = chart.center.font;
                    ctx.fillStyle = chart.center.fillStyle;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText(centerConfig.text, centerX, centerY);
                    ctx.restore();
                }
            },
        })
    
    
        var config = {
            type: 'doughnut',
            data: {
                labels: [
                    langArr[language].odd,
                    langArr[language].even
                ],
                datasets: [{
                        data: [60, 40],
                        backgroundColor: [
                            "#00aeef",
                            "#555555"
                        ],
                        borderColor: [
                            "#00aeef",
                            "#555555"
                        ]
                    }]
            },
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false
                },
                elements: {
                    center: {
                        // the longest text that could appear in the center
                        maxText: '100%',
                        text: langArr[language].odd + ' 42%',
                        fontColor: '#555555',
                        fontFamily: "'proxima-nova-regular",
                        fontStyle: 'normal',
                        fontSize: 15,
                        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                        // if these are not specified either, we default to 1 and 256
                        minFontSize: 1,
                        maxFontSize: 256,
                    }
                }
            }
        };
    
        var ctx = document.getElementById("myChartDogPie3").getContext("2d");
        var myChart = new Chart(ctx, config);
    
        //Chart 4
    
        Chart.pluginService.register({
            afterUpdate: function (chart) {
                if (chart.config.options.elements.center) {
                    var helpers = Chart.helpers;
                    var centerConfig = chart.config.options.elements.center;
                    var globalConfig = Chart.defaults.global;
                    var ctx = chart.chart.ctx;
    
                    var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
                    var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);
    
                    if (centerConfig.fontSize)
                        var fontSize = centerConfig.fontSize;
                    // figure out the best font size, if one is not specified
                    else {
                        ctx.save();
                        var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                        var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                        var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);
    
                        do {
                            ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                            var textWidth = ctx.measureText(maxText).width;
    
                            // check if it fits, is within configured limits and that we are not simply toggling back and forth
                            if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                                fontSize += 1;
                            else {
                                // reverse last step
                                fontSize -= 1;
                                break;
                            }
                        } while (true)
                        ctx.restore();
                    }
    
                    // save properties
                    chart.center = {
                        font: helpers.fontString(fontSize, fontStyle, fontFamily),
                        fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
                    };
                }
            },
            afterDraw: function (chart) {
                if (chart.center) {
                    var centerConfig = chart.config.options.elements.center;
                    var ctx = chart.chart.ctx;
    
                    ctx.save();
                    ctx.font = chart.center.font;
                    ctx.fillStyle = chart.center.fillStyle;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText(centerConfig.text, centerX, centerY);
                    ctx.restore();
                }
            },
        })
    
    
        var config = {
            type: 'doughnut',
            data: {
                labels: [
                    langArr[language].odd,
                    langArr[language].even
                ],
                datasets: [{
                        data: [60, 40],
                        backgroundColor: [
                            "#481a93",
                            "#555555"
                        ],
                        borderColor: [
                            "#481a93",
                            "#555555"
                        ]
                    }]
            },
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false
                },
                elements: {
                    center: {
                        // the longest text that could appear in the center
                        maxText: '100%',
                        text: langArr[language].even + ' 52%',
                        fontColor: '#555555',
                        fontFamily: "'proxima-nova-regular",
                        fontStyle: 'normal',
                        fontSize: 15,
                        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                        // if these are not specified either, we default to 1 and 256
                        minFontSize: 1,
                        maxFontSize: 256,
                    }
                }
            }
        };
    
        var ctx = document.getElementById("myChartDogPie4").getContext("2d");
        var myChart = new Chart(ctx, config);
    
        //Chart 5
    
        Chart.pluginService.register({
            afterUpdate: function (chart) {
                if (chart.config.options.elements.center) {
                    var helpers = Chart.helpers;
                    var centerConfig = chart.config.options.elements.center;
                    var globalConfig = Chart.defaults.global;
                    var ctx = chart.chart.ctx;
    
                    var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
                    var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);
    
                    if (centerConfig.fontSize)
                        var fontSize = centerConfig.fontSize;
                    // figure out the best font size, if one is not specified
                    else {
                        ctx.save();
                        var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                        var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                        var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);
    
                        do {
                            ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                            var textWidth = ctx.measureText(maxText).width;
    
                            // check if it fits, is within configured limits and that we are not simply toggling back and forth
                            if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                                fontSize += 1;
                            else {
                                // reverse last step
                                fontSize -= 1;
                                break;
                            }
                        } while (true)
                        ctx.restore();
                    }
    
                    // save properties
                    chart.center = {
                        font: helpers.fontString(fontSize, fontStyle, fontFamily),
                        fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
                    };
                }
            },
            afterDraw: function (chart) {
                if (chart.center) {
                    var centerConfig = chart.config.options.elements.center;
                    var ctx = chart.chart.ctx;
    
                    ctx.save();
                    ctx.font = chart.center.font;
                    ctx.fillStyle = chart.center.fillStyle;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText(centerConfig.text, centerX, centerY);
                    ctx.restore();
                }
            },
        })
    
    
        var config = {
            type: 'doughnut',
            data: {
                labels: [
                    "< 7.5",
                    "> 7.5"
                ],
                datasets: [{
                        data: [60, 40],
                        backgroundColor: [
                            "#fff200",
                            "#555555"
                        ],
                        borderColor: [
                            "#fff200",
                            "#555555"
                        ]
                    }]
            },
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false
                },
                elements: {
                    center: {
                        // the longest text that could appear in the center
                        maxText: '100%',
                        text: '1+2',
                        fontColor: '#555555',
                        fontFamily: "'proxima-nova-regular",
                        fontStyle: 'normal',
                        fontSize: 18,
                        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                        // if these are not specified either, we default to 1 and 256
                        minFontSize: 1,
                        maxFontSize: 256,
                    }
                }
            }
        };
    
        var ctx = document.getElementById("myChartDogPie5").getContext("2d");
        var myChart = new Chart(ctx, config);
        document.getElementById('js-legend-dog5').innerHTML = myChart.generateLegend();
    
        //Chart 6
    
        Chart.pluginService.register({
            afterUpdate: function (chart) {
                if (chart.config.options.elements.center) {
                    var helpers = Chart.helpers;
                    var centerConfig = chart.config.options.elements.center;
                    var globalConfig = Chart.defaults.global;
                    var ctx = chart.chart.ctx;
    
                    var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
                    var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);
    
                    if (centerConfig.fontSize)
                        var fontSize = centerConfig.fontSize;
                    // figure out the best font size, if one is not specified
                    else {
                        ctx.save();
                        var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                        var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                        var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);
    
                        do {
                            ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                            var textWidth = ctx.measureText(maxText).width;
    
                            // check if it fits, is within configured limits and that we are not simply toggling back and forth
                            if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                                fontSize += 1;
                            else {
                                // reverse last step
                                fontSize -= 1;
                                break;
                            }
                        } while (true)
                        ctx.restore();
                    }
    
                    // save properties
                    chart.center = {
                        font: helpers.fontString(fontSize, fontStyle, fontFamily),
                        fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
                    };
                }
            },
            afterDraw: function (chart) {
                if (chart.center) {
                    var centerConfig = chart.config.options.elements.center;
                    var ctx = chart.chart.ctx;
    
                    ctx.save();
                    ctx.font = chart.center.font;
                    ctx.fillStyle = chart.center.fillStyle;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText(centerConfig.text, centerX, centerY);
                    ctx.restore();
                }
            },
        })
    
    
        var config = {
            type: 'doughnut',
            data: {
                labels: [
                    "< 7.5",
                    "> 7.5"
                ],
                datasets: [{
                        data: [60, 40],
                        backgroundColor: [
                            "#ff9000",
                            "#555555"
                        ],
                        borderColor: [
                            "#ff9000",
                            "#555555"
                        ]
                    }]
            },
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false
                },
                elements: {
                    center: {
                        // the longest text that could appear in the center
                        maxText: '100%',
                        text: '1+2+3',
                        fontColor: '#555555',
                        fontFamily: "'proxima-nova-regular",
                        fontStyle: 'normal',
                        fontSize: 18,
                        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                        // if these are not specified either, we default to 1 and 256
                        minFontSize: 1,
                        maxFontSize: 256,
                    }
                }
            }
        };
    
        var ctx = document.getElementById("myChartDogPie6").getContext("2d");
        var myChart = new Chart(ctx, config);
        document.getElementById('js-legend-dog6').innerHTML = myChart.generateLegend();
    }
    
});


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/charts.js
// module id = 1944
// module chunks = 7